import { createIcon } from "@chakra-ui/react";

export const NavLogoSmallWhite = createIcon({
  displayName: "NavLogoSmallWhite",
  viewBox: "218 224 606 604",
  path: (
    <g fill="white">
      <rect x="474.5" y="239" width="92.7" height="588.4" rx="41" ry="41" />
      <rect x="607.7" y="342.9" width="75.7" height="379.7" rx="37.9" ry="37.9" />
      <rect x="358.3" y="342.9" width="75.7" height="379.7" rx="37.9" ry="37.9" />
      <rect x="233.6" y="411.2" width="75.7" height="245.1" rx="37.9" ry="37.9" />
      <rect x="732.4" y="411.2" width="75.7" height="245.1" rx="37.9" ry="37.9" />
    </g>
  )
});
